function toFiniteNumber(value, fallback = Number.POSITIVE_INFINITY) {
  return Number.isFinite(value) ? Number(value) : fallback;
}

function titleCase(value) {
  const text = String(value || '').trim();
  if (!text) return '';
  return `${text.charAt(0).toUpperCase()}${text.slice(1)}`;
}

function humanizeNodeLabel(value) {
  const text = String(value || '').trim();
  if (!text) return 'this part';
  if (text.includes(' ')) return text;
  return text.replace(/[_-]+/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase());
}

function formatStepLabel(stepNumber) {
  const step = Number(stepNumber);
  if (!Number.isFinite(step) || step <= 0) return 'Scene moment';
  return `Scene moment ${step}`;
}

export function formatCheckpointLabel(checkpoint) {
  if (!checkpoint || typeof checkpoint !== 'object') return 'Checkpoint';

  const nodeLabel = humanizeNodeLabel(checkpoint.nodeTitle || checkpoint.nodeId);
  if (Number.isFinite(checkpoint.timelineStep)) {
    return `${nodeLabel} - ${formatStepLabel(checkpoint.timelineStep)}`;
  }

  if (checkpoint.slidePhase) {
    return `${nodeLabel} - ${titleCase(checkpoint.slidePhase)}`;
  }

  return nodeLabel;
}

export function buildCheckpointOptions(checkpoints) {
  if (!Array.isArray(checkpoints) || checkpoints.length === 0) return [];

  const seen = new Set();
  return checkpoints
    .filter((checkpoint) => checkpoint && typeof checkpoint === 'object' && checkpoint.eventId)
    .sort((a, b) => {
      const byNodeIndex = toFiniteNumber(a.nodeIndex) - toFiniteNumber(b.nodeIndex);
      if (byNodeIndex !== 0) return byNodeIndex;

      const byTimelineStep = toFiniteNumber(a.timelineStep) - toFiniteNumber(b.timelineStep);
      if (byTimelineStep !== 0) return byTimelineStep;

      const byCapturedAt = toFiniteNumber(a.capturedAt) - toFiniteNumber(b.capturedAt);
      if (byCapturedAt !== 0) return byCapturedAt;

      return String(a.eventId).localeCompare(String(b.eventId));
    })
    .filter((checkpoint) => {
      const eventId = String(checkpoint.eventId);
      if (seen.has(eventId)) return false;
      seen.add(eventId);
      return true;
    })
    .map((checkpoint) => ({
      value: String(checkpoint.eventId),
      label: formatCheckpointLabel(checkpoint),
      checkpoint,
    }));
}
